export const name = 'siteRendererConfigurationService' as const
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/site-service-renderer-configuration' as const
export { VSM_EDITOR_CONFIGS_EXPERIMENT as editorExperiment } from '@wix/thunderbolt-symbols'
